// v3 account step: the single account list (stories 13-16). Pure and React-free so it is unit-
// testable (this repo's `bun test` has no DOM).
//
// Order: Demo mode first, then accounts with a saved sizing A-Z, then the rest A-Z. "Has a saved
// sizing" is `latestSnapshot != null`, which the existing owned-accounts endpoint already returns.
// The open-opportunity rule (0 -> account only, 1 -> automatic, 2+ -> inline picker) is reused
// from the v2 account-link model (`opportunityModeFor`), not re-implemented.

import type { OwnedAccount } from '../api-client';
import { filterAccountsByName } from '../components/account-link-model';

export { opportunityModeFor } from '../components/account-link-model';

export type AccountListEntry = { kind: 'demo' } | { kind: 'account'; account: OwnedAccount };

export const hasSavedSizing = (account: OwnedAccount): boolean => account.latestSnapshot != null;

const byName = (a: OwnedAccount, b: OwnedAccount): number =>
  a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }) || a.id.localeCompare(b.id);

/** Accounts with a saved sizing (A-Z), then the rest (A-Z). Returns a new array. */
export function sortAccountsForStep(accounts: readonly OwnedAccount[]): OwnedAccount[] {
  return [
    ...accounts.filter(hasSavedSizing).sort(byName),
    ...accounts.filter((a) => !hasSavedSizing(a)).sort(byName),
  ];
}

/** Demo mode always first and never filtered out; the name filter only narrows the accounts. */
export function buildAccountList(accounts: readonly OwnedAccount[], query = ''): AccountListEntry[] {
  const filtered = filterAccountsByName([...accounts], query);
  return [
    { kind: 'demo' },
    ...sortAccountsForStep(filtered).map((account): AccountListEntry => ({ kind: 'account', account })),
  ];
}
